import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {groupByKey} from "../../utils/utils";
import {FLIP_MATCH_STATE_TYPE} from "../../containers/FlipMatch/constants";

function FlipMatchProgress(props) {
    const {flip, className, itemClassName} = props;
    const [t] = useTranslation();
    const allGroupItems = flip.collection.cards.length ? groupByKey(flip.collection.cards, 'group') : [];
    const groups = flip.flipped.length ? groupByKey(flip.flipped, 'group') : [];
    const checkList = Object.values(groups).map((groupItems) => {
        const card = Object.values(groupItems).filter((item) => {
            return item.frontIcon ? item : false ;
        })[0];

        if (card) {
            const FrontIconTag = card.frontIcon.tag;
            return (
                <div key={card.name} className={itemClassName}>
                    {FrontIconTag &&
                        <FrontIconTag {...card.frontIcon.props} />
                    }
                </div>
            )
        }
        else {
            return (<></>)
        }
    });

    const countdownValue = Object.keys(allGroupItems).length - Object.keys(groups).length;
    return (
        <div className={className}>
            {groups &&
                <div className={`${className}-counter animated slideInLeft delay-1s fast`}>
                    <div className={`${className}-counter-inner`}>
                        <p className="animated jackInTheBox delay-1s">
                            {t("countdown")}<br/>
                            <span key={countdownValue} className="countdown-number">{countdownValue}</span>
                        </p>
                    </div>
                </div>
            }
            <div className={`${className}-items`}>
                {checkList}
            </div>
        </div>
    )
}

FlipMatchProgress.propTypes = {
    flip: FLIP_MATCH_STATE_TYPE,
    className: PropTypes.string,
    itemClassName: PropTypes.string
};

FlipMatchProgress.defaultProps = {
    flip: {},
    className: '',
    itemClassName: ''
};

export default FlipMatchProgress;